import React, {
    useState
} from 'react';
import {
    Popover, PopoverTrigger, PopoverContent
} from 'shared/components/ui/popover';
import {
    Input
} from 'shared/components/ui/input';
import {
    Label
} from 'shared/components/ui/label';
import {
    Slider
} from 'shared/components/ui/slider';
import {
    Button
} from 'shared/components/ui/button';
import {
    Settings2
} from 'lucide-react';

const CerebrasConfiguration = ({
    parametersCerebras, setParametersCerebras
}) => {
    const [tempLimit] = useState({
        min: 0,
        max: 1.5
    });
    const [topPLimit] = useState({
        min: 0,
        max: 1
    });

    return (
        <Popover>
            <PopoverTrigger asChild>
                <div className=''>
                    <Button aria-haspopup="true" size="icon" variant="ghost">
                        <Settings2 className="h-5 w-5" />
                    </Button>
                </div>
            </PopoverTrigger>

            <PopoverContent className="w-80 select-none" align="center">
                <div className="grid gap-4">
                    <div className="space-y-2">
                        <h4 className="font-medium leading-none text-sm">Configure Cerebras Model</h4>
                        <p className="text-xs text-muted-foreground">
                            Set the parameters for selected Cerebras model.
                        </p>
                    </div>
                    <div className="grid gap-4">
                        <div className="grid grid-cols-3 items-center gap-y-0 gap-x-2">
                            <Label htmlFor="maxCompletionTokens" className="col-span-2">Max Completion Tokens</Label>
                            <Input
                                id="maxCompletionTokens"
                                type="number"
                                value={parametersCerebras.max_completion_tokens}
                                step={1}
                                onChange={(e)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    max_completion_tokens: Number(e.target.value)
                                });}}
                                className="col-span-1 h-8"
                            />
                        </div>

                        <div className="grid grid-cols-3 items-center gap-y-0 gap-x-2">
                            <Label htmlFor="temp" className="col-span-2">Temperature</Label>
                            <Input
                                id="temp"
                                type="number"
                                value={parametersCerebras.temperature}
                                step={0.1}
                                max={tempLimit.max}
                                min={tempLimit.min}
                                onChange={(e)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    temperature: Number(e.target.value)
                                });}}
                                className="col-span-1 h-8"
                            />
                            <Slider
                                id="temp"
                                value={[parametersCerebras.temperature]}
                                onValueChange={(value)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    temperature: Number(value)
                                });}}
                                step={0.1}
                                max={tempLimit.max}
                                min={tempLimit.min}
                                className="col-span-3 h-8"
                            />
                        </div>

                        <div className="grid grid-cols-3 items-center gap-y-0 gap-x-2">
                            <Label htmlFor="topP" className="col-span-2">Top P</Label>
                            <Input
                                id="topP"
                                type="number"
                                value={parametersCerebras.top_p}
                                step={0.1}
                                max={topPLimit.max}
                                min={topPLimit.min}
                                onChange={(e)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    top_p: Number(e.target.value)
                                });}}
                                className="col-span-1 h-8"
                            />
                            <Slider
                                id="topP"
                                value={[parametersCerebras.top_p]}
                                onValueChange={(value)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    top_p: Number(value)
                                });}}
                                step={0.1}
                                max={topPLimit.max}
                                min={topPLimit.min}
                                className="col-span-3 h-8"
                            />
                        </div>

                        <div className="grid grid-cols-3 items-center gap-y-0 gap-x-2">
                            <Label htmlFor="seed" className="col-span-2">Seed (Optional)</Label>
                            <Input
                                id="seed"
                                type="number"
                                value={parametersCerebras.seed}
                                step={1}
                                onChange={(e)=>{setParametersCerebras({
                                    ...parametersCerebras,
                                    seed: e.target.value ? Number(e.target.value) : null
                                });}}
                                className="col-span-1 h-8"
                                placeholder="null"
                            />
                        </div>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    );
};

export default CerebrasConfiguration;
